// useOpenAIMultiModalClient.js
import { ref } from 'vue';

// Replace with your actual OpenAI API key (ideally retrieved securely)
const OPENAI_API_KEY = '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'; 

export function useOpenAIMultiModalClient() {
  // --- Reactive State ---
  const isLoading = ref(false);
  const error = ref(null);

  /**
   * Sends a Base64 encoded image and a text prompt to the GPT-4o model for analysis.
   * * @param {string} base64Image The Base64 image data (the part *after* 'data:image/jpeg;base64,').
   * @param {string} mimeType The MIME type of the image (e.g., 'image/png').
   * @param {string} prompt The text prompt for the analysis.
   * @returns {Promise<string>} A promise that resolves with the AI's text response.
   */
  const analyzeBase64Image = async (base64Image, mimeType, prompt) => {
    if (!base64Image || !mimeType || !prompt) {
      const missing = [];
      if (!base64Image) missing.push('Base64 Image');
      if (!mimeType) missing.push('MIME Type');
      if (!prompt) missing.push('Prompt');
      throw new Error(`Missing required arguments: ${missing.join(', ')}.`);
    }
    
    // Clear previous error and set loading state
    error.value = null;
    isLoading.value = true;

    try {
      // 1. Construct the API request payload
      const payload = {
        model: "gpt-4o",
        messages: [
          {
            role: "user",
            content: [
              // Text prompt part
              { type: "text", text: prompt },
              // Image data part (Base64)
              {
                type: "image_url",
                image_url: {
                  // Reconstruct the full data URI
                  url: `${base64Image}`,
                  detail: "low" // 'low' is faster and cheaper
                },
              },
            ],
          },
        ],
      };

      // 2. Send the request to the Chat Completions API
      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${OPENAI_API_KEY}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error?.message || `API request failed with status ${response.status}`);
      }

      const data = await response.json();
      
      // Extract and return the model's text response
      return data.choices[0].message.content;

    } catch (err) {
      console.error('OpenAI API Error:', err);
      error.value = err.message;
      throw err; // Re-throw the error so the calling component can handle it
    } finally {
      isLoading.value = false;
    }
  };


  return {
    // State
    isLoading,
    error,
    
    // Methods
    analyzeBase64Image,
  };
}